import React from 'react';
import Script from 'react-load-script'
import '../css/elicit.less';

class Elicit extends React.Component {

    constructor(props) {
        super(props);
        this.elicitScript = "//cloud-hp-store-en-us.elicitapp.com/js.ashx?f=elicit.tag.web.js";
        this.scriptLoaded = false;
        this.handleScriptCreate = this.handleScriptCreate.bind(this);
        this.handleScriptError = this.handleScriptError.bind(this);
        this.handleScriptLoad = this.handleScriptLoad.bind(this);
    }

    // add logging ? 
    handleScriptCreate() {
      this.scriptLoaded = false;
    }
     
    handleScriptError() {
      this.scriptLoaded = false;
    }
     
    handleScriptLoad() {
      this.scriptLoaded = true;
    }

    render() {
        return(
            <div id="elicit-finder">
                <form id="elc-form">
                    <input type="text" name="q" id="q" className="elc-searchInput" autoComplete="off" autoCorrect="off" autoCapitalize="off" spellCheck="false" disablelegacyinputchecking="true" title="" placeholder={this.props.placeholder} />
                </form>
                
                {
                    !this.scriptLoaded &&
                    <Script 
                        url={this.elicitScript}
                        onCreate={this.handleScriptCreate}
                        onError={this.handleScriptError}
                        onLoad={this.handleScriptLoad}
                    />
                }
                
            </div>
        );
    }
}

Elicit.defaultProps = {
    placeholder: "Search by printer name, model, or cartridge #"
}

export default Elicit;